import imageObject from './imageObject';

/**
 * Brand type
 * DOC: https://schema.org/Brand
 */

export default ({
  logo,
  slogan
}) => ({
  '@type': 'Brand',
  logo: imageObject(logo),
  slogan: slogan
});